export default __webpack_public_path__ + "static/media/promo_coda_large.16a4b7b3.jpg";